import { Link } from 'react-router-dom';
import { Music, Sparkles, ChevronRight } from 'lucide-react';

const HUB_CARDS = [
  {
    slug: 'concerte',
    title: 'Concerte',
    description: 'Concerte muzicale live cu artiști internaționali și români',
    icon: Music,
    image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=900&q=80',
    accent: 'from-purple-600/40 to-pink-500/30',
    iconBg: 'bg-purple-500/20 text-purple-200',
    testid: 'hub-card-concerte',
  },
  {
    slug: 'evenimente',
    title: 'Evenimente',
    description: 'Spectacole culturale, evenimente sportive și alte experiențe unice',
    icon: Sparkles,
    image: 'https://images.unsplash.com/photo-1503095396549-807759245b35?w=900&q=80',
    accent: 'from-amber-500/40 to-rose-500/30',
    iconBg: 'bg-amber-400/20 text-amber-200',
    testid: 'hub-card-evenimente',
  },
];

export default function ConcerteHubPage() {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="concerte-hub-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-white mb-2" data-testid="page-title">
            Concerte & Evenimente
          </h1>
          <p className="text-white/60">Alege o categorie pentru a explora ofertele disponibile</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {HUB_CARDS.map(card => {
            const Icon = card.icon;
            return (
              <Link
                key={card.slug}
                to={`/concerte/${card.slug}`}
                className="group relative h-72 md:h-80 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_30px_rgba(212,175,55,0.25)]"
                data-testid={card.testid}
              >
                <img
                  src={card.image}
                  alt={card.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                <div className={`absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-transparent z-10`} />
                <div className={`absolute inset-0 bg-gradient-to-br ${card.accent} z-[5] opacity-70`} />
                <div className="absolute inset-0 z-20 flex flex-col justify-end p-7">
                  <div className={`w-12 h-12 rounded-xl ${card.iconBg} flex items-center justify-center mb-4 backdrop-blur-sm`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-heading font-bold text-2xl md:text-3xl text-white mb-2">{card.title}</h3>
                  <p className="text-white/80 text-sm md:text-base mb-3 max-w-md">{card.description}</p>
                  <div className="flex items-center gap-1 text-gold text-sm font-medium opacity-80 group-hover:opacity-100 transition-opacity">
                    <span>Explorează</span>
                    <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
